import React from 'react';
import {Label} from '@fluentui/react';
import {setManChoice} from "../../../actions/CreateSiteActions/dimensionActions";
import {connect} from "react-redux";
import TreeComponent from "../CommonComponents/TreeComponent";
import { isManagementValid } from '../Step3/Validator';
import InfoTooltip from '../../formFields/InfoTooltip';
import NewModal from "./NewModal";
import {ItemPicker} from "../CommonComponents/ItemPicker";
import Warning from '../CommonComponents/Warning';
import Api from '../../../services/Api'

class Management extends React.Component {

    constructor(props)
    {
        super(props)
        this.state = {
            firstLevel : []
        }
    }

    componentDidMount() {       

        if (!this.props.selectedMan){
            if (this.props.managementConfig.defaultKey) {
                this.fitDefaultChoice(this.props.managementConfig.defaultKey);
            } else {
                if(this.props.currentUser && this.props.managementConfig.onlyChildrenAllowed !== true)
                    this.getManagementKey()
            }
        }

        if (!this.props.managementConfig.isDisabled) {
            this.fitPossibilities();
        }
    }

    fitDefaultChoice(defaultKey) {
        Api.get(`/Management?key=${defaultKey}`)
            .then(res => res.data)
            .then(posts => {
                if(posts && posts.length > 0)
                    this.props.setManagement(posts[0]);
            });
    }

    fitPossibilities() {
        Api.get(`/Management?${this.props.managementConfig.onlyChildrenAllowed ? `key=${this.props.managementConfig.defaultKey}&parent=all` : 'parent=abb'}`)
            .then(res => res.data)
            .then(posts => {
                this.setState({firstLevel: posts});
            });
    }

    getManagementKey() {
        Api.get(`/User/GetUserById?userId=${this.props.currentUser.id}`)
            .then(res => res.data)
            .then(posts => {
                if(posts && posts.managementKey)
                    this.fitDefaultChoice(posts.managementKey);
            });
    }

    render() {
        const fulladdressSearch = `/Management?${this.props.managementConfig.onlyChildrenAllowed ? `parent=${this.props.managementConfig.defaultKey}&` : ''}search=`;
        const fulladdressTree =  '/Management'
        const geo = this.state.firstLevel.map(item => 
            <TreeComponent
                key = {item.key}
                child = {item}
                itemSelector = {this.props.setManagement}
                selectedItem = {this.props.selectedMan}
                url = {fulladdressTree}
            />)

        const warning = this.props.possibleWarning && !isManagementValid()
                        ? <Warning element="withlabel-basepicker"/> : null;
        const error = warning && <div className='errorMessage'>Please select an option</div>;
        const toModal =  <div className='tree'>
            {geo}
        </div>

        return (
            <div>
                <div className="wizard-inside">
                    <div className="item-title">
                        Specify the organizational context for this site
                        <InfoTooltip content='Select the organizational area which holds the ownership for this site' />
                    </div>
                    {warning}
                    <ItemPicker key = "man"
                        itemSelector={this.props.setManagement}
                        searchTitle="Start typing to search for Business area, Business line, Function, etc."
                        url={fulladdressSearch}
                        selection= {this.props.selectedMan}
                        isPickerDisabled = {this.props.managementConfig.isDisabled}
                    />
                    <Label style={{marginTop:'10px'}}>Or select item from tree</Label>
                    <NewModal
                        component = {toModal}
                        selection = {this.props.selectedMan}
                        isPickerDisabled = {this.props.managementConfig.isDisabled}
                    />
                    {error}
                </div>
            </div>
        );
    }
}

const mapActionToProp = {
    setManagement: setManChoice
}

const mapStateToProps  = state => ({
    selectedMan: state.newSite.management,
    possibleWarning : state.wizard.nextStepRequested,
    managementConfig: (state.newSite.Template.config || {}).managementConfig || {},
    currentUser: state.user.currentUser
})

export default connect(mapStateToProps, mapActionToProp)(Management)








// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/Management.js